module.exports = "/_next/static/chromiums/twitter-512x512-planet-43d7fab5903f55bc901fcf352ed6f91f.jpg";